'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/input-number/style/css');

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _css3 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 客户充值按钮及弹出表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var UserRecharge = _react2.default.createClass({
    displayName: 'UserRecharge',
    onOk: function onOk(form) {

    },
    render: function render() {
        var _props = this.props,
            user = _props.user,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: {
                span: 6
            },
            wrapperCol: {
                span: 14
            }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), title: '\u5145\u503C' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u5145\u503C\u91D1\u989D',
                        required: true
                    }),
                    getFieldDecorator('money', {
                        rules: [{ required: true, message: '请输入充值金额!' }]
                    })(_react2.default.createElement(_inputNumber2.default, null))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u5907\u6CE8'
                    }),
                    getFieldDecorator('note')(_react2.default.createElement(_input2.default, { type: 'textarea' }))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(UserRecharge);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_recharge.js
// module id = 1330
// module chunks = 0